import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { ItemMetadata } from "@common/ADAPT.Common.Model/organisation/item";
import { MeetingAgendaItem } from "@common/ADAPT.Common.Model/organisation/meeting-agenda-item";
import { MeetingNoteType, MeetingNoteTypeMetadata } from "@common/ADAPT.Common.Model/organisation/meeting-note";
import { IAdaptMenuItem, MenuComponent } from "@common/ux/menu/menu.component";
import { KanbanService } from "@org-common/lib/kanban/kanban.service";
import { KanbanUiService } from "@org-common/lib/kanban/kanban-ui.service";
import { ObjectivesAuthService } from "@org-common/lib/objectives/objectives-auth.service";
import { lastValueFrom } from "rxjs";
import { MeetingsUiService } from "../meetings-ui.service";

@Component({
    selector: "adapt-agenda-item-action-menu",
    templateUrl: "./agenda-item-action-menu.component.html",
    standalone: false,
})
export class AgendaItemActionMenuComponent implements OnChanges {
    @Input() public hideEditAgendaItem = true;
    @Input() public hideAddActions = false;
    @Input() public agendaItem!: MeetingAgendaItem;
    @Output() public actionPerformed = new EventEmitter<void>();
    @Output() public visibilityChanged = new EventEmitter<boolean>();

    public itemMenu: IAdaptMenuItem[] = [];

    public constructor(
        private kanbanUiService: KanbanUiService,
        private kanbanService: KanbanService,
        private objectivesAuthService: ObjectivesAuthService,
        private meetingsUiService: MeetingsUiService,
    ) { }

    public async ngOnChanges() {
        // this is the same permission as add action in meeting-sidebar-agenda-item.component
        const canEditAnyBoard = await lastValueFrom(this.kanbanService.hasAnyEditableBoard());
        const canReadAnyObjective = await lastValueFrom(this.objectivesAuthService.hasAnyReadAccessToObjective$);
        this.itemMenu = [{
            text: "",
            icon: MenuComponent.SmallRootMenu.icon,
            items: [
                {
                    text: "Add action",
                    visible: !this.hideAddActions && canEditAnyBoard,
                    icon: ItemMetadata.IconClass,
                    onClick: () => this.kanbanUiService.createActionForAgendaItem(this.agendaItem).subscribe(() => this.actionPerformed.emit()),
                },
                {
                    beginGroup: true,
                    visible: !this.hideAddActions,
                    text: "Add decision",
                    icon: MeetingNoteTypeMetadata.IconClass[MeetingNoteType.Decision],
                    onClick: () => this.meetingsUiService.createMeetingNoteForAgendaItem(this.agendaItem, MeetingNoteType.Decision).subscribe(() => this.actionPerformed.emit()),
                },
                {
                    text: "Add minute",
                    visible: !this.hideAddActions,
                    icon: MeetingNoteTypeMetadata.IconClass[MeetingNoteType.Minute],
                    onClick: () => this.meetingsUiService.createMeetingNoteForAgendaItem(this.agendaItem, MeetingNoteType.Minute).subscribe(() => this.actionPerformed.emit()),
                },
                {
                    beginGroup: !this.hideAddActions,
                    text: "Link an action",
                    icon: "fal fa-fw fa-paperclip",
                    visible: canEditAnyBoard,
                    onClick: () => this.meetingsUiService.openItemLinkDialog(this.agendaItem).subscribe(() => this.actionPerformed.emit()),
                },
                {
                    text: "Link an objective",
                    icon: "fal fa-fw fa-cube",
                    visible: canReadAnyObjective,
                    onClick: () => this.meetingsUiService.openObjectiveLinkDialog(this.agendaItem).subscribe(() => this.actionPerformed.emit()),
                },
                {
                    beginGroup: true,
                    text: "Edit agenda item",
                    visible: !this.hideEditAgendaItem,
                    icon: "fal fa-fw fa-edit",
                    onClick: () => this.meetingsUiService.editMeetingAgendaItem(this.agendaItem, true).subscribe(() => this.actionPerformed.emit()),
                },
            ],
        }];
    }
}
